module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pricing-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pricing-container__right"
  }, [_c('h2', [_vm._v("En stærk samlet pakke til jeres skole")]), _vm._v(" "), _c('ul', {
    staticClass: "pricing-features"
  }, [_vm._l((_vm.features), function(feature) {
    return _c('li', [_c('span', {
      staticClass: "icon-checkmark4 color-blue"
    }), _vm._v(" " + _vm._s(feature))])
  }), _vm._v(" "), _c('li', [_vm._v("... og meget mere")])], 2), _vm._v(" "), _c('h4', [_vm._v("Betaling hver måned eller årligt")]), _vm._v(" "), _c('p', [_vm._v("I bestemmer selv, om I vil faktureres hver måned eller hvert år")]), _vm._v(" "), _c('h4', [_vm._v("Prøv gratis i 30 dage")]), _vm._v(" "), _c('p', [_vm._v("Du kan prøve Docendo i 30 dage helt gratis. Du binder dig ikke til at købe systemet, og vi beder ikke\n        om dine kontooplysninger.\n        Efter 30 dage bestemmer du selv, om du vil fortsætte med Docendo.\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-container__left"
  }, [_c('div', {
    staticClass: "pricing-box"
  }, [_c('h2', [_vm._v("Skolens samlede elevtal")]), _vm._v(" "), _c('p', [_vm._v("Betal for skolens samlede elevtal - og få et ubegrænset antal brugere på")]), _vm._v(" "), _c('h3', [_vm._v("5"), _c('span', {
    staticClass: "text-grey",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("kr")])]), _vm._v(" "), _c('p', [_vm._v("pr. elev / måned\n          ")]), _c('p', [_vm._v("+ 499 kr pr. måned i licens pr. institution"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("Alle priser er eksklusiv moms")])]), _vm._v(" "), _c('p')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6730c6d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Buy/Pricing.vue
// module id = 1974
// module chunks = 1